import React from "react";
import { useLocation } from "react-router-dom";
import PackageBookingPopup from "../components/PackageBookingPopup";

const PackageBooking = () => {
  const location = useLocation();
  const { pkg, isWithFlight, withFlightTotalSalePrice, doublePrice,hotel_ratings } = location.state || {};

  return (
    <div className="booking-page-container">
      <h2>Book Your Package</h2>

      <PackageBookingPopup
        pkg={pkg}
        isWithFlight={isWithFlight}
        withFlightTotalSalePrice={withFlightTotalSalePrice}
        doublePrice={doublePrice}
        hotel_ratings={hotel_ratings}
      />
    </div>
  );
};

export default PackageBooking;
